import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-plane",
  "use": "icon-plane-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-plane\"><defs><style type=\"text/css\"></style></defs><path d=\"M767.9488 1024l-338.7648-254.1312L895.8976 128l-601.088 541.0816L0 448 1024 0z\" fill=\"#386BF3\" p-id=\"1679\" /><path d=\"M246.5536 699.904l188.928 141.44-203.7248 134.4z\" fill=\"#3D4265\" p-id=\"1680\" /><path d=\"M895.8976 128l-601.088 541.056 134.4 100.8128z\" fill=\"#C3D2FB\" p-id=\"1681\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol